/** @jsx h */
import { h, Component, createRef } from 'preact'
import ClaimCard from './ClaimCard'
import TagLine from '../TagLine'

class ClaimCardEmbed extends Component {
  constructor (props) {
    super(props)
    this.outerRef = createRef()
  }

  componentDidMount () {
    const height = this.outerRef.current.clientHeight
    if (window.self !== window.top) {
      const secret = window.location.hash.replace(
        /.*secret=([\d\w]{10}).*/,
        '$1'
      )
      window.parent.postMessage(
        {
          message: 'height',
          value: height,
          secret
        },
        '*'
      )
    }
  }

  render () {
    const { modalUrl } = this.props

    return (
      <a
        class='ClaimCard-action--embed'
        href={modalUrl}
        ref={this.outerRef}
      >
        <ClaimCard {...this.props} footer={<TagLine embed />} />
      </a>
    )
  }
}

export default ClaimCardEmbed
